// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input:focus {\n  outline: 0;\n}\n\n.swal2-container {\n  z-index: 10001;\n}\n", "",{"version":3,"sources":["webpack://./web.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB","sourcesContent":["input:focus {\n  outline: 0;\n}\n\n.swal2-container {\n  z-index: 10001;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
